import { TrafficCone, Trash2 } from "lucide-react";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import SearchSelect from "../../components/SearchSelect";
import Select from "../../components/Select";
import TextInput from "../../components/TextInput";

const statusOptions = ["N", "A", "E", "Q", "W", "C"];

const LevelCrossing = (props) => {
  const data = props.levelCrossingData || {};
  const index = props.levelCrossingIndex;
  const possessionIndex = props.possessionIndex;
  const path = `possessions.${possessionIndex}.level_crossings.${index}`;
  const allLines = props.possessionData?.worksites?.flatMap((worksite) => worksite?.lines_at_site || []) || [];
  const lineOptions = allLines.filter((line) => line?.name).map((line) => ({ label: line.name, value: line.line_reference, line }));
  const selected = (data.lines || []).map((line) => lineOptions.find((option) => option.value === line.line_reference) || ({ label: line.name, value: line.line_reference, line }));

  return (
    <section className="wsm-inline-editor">
      <div className="wsm-inline-editor__heading">
        <span className="wsm-inline-editor__icon"><TrafficCone aria-hidden="true" /></span>
        <strong>Level crossing {index + 1}</strong>
        <IconButton aria-label={`Remove level crossing ${index + 1}`} disabled={index === 0} icon={Trash2} onClick={() => props.handleRemoveFormRow(`possessions.${possessionIndex}.level_crossings`, index, true, "level crossing")} size="compact" variant="destructive" />
      </div>
      <div className="wsm-inline-editor__fields wsm-inline-editor__fields--three">
        <FormField id={`level-crossing-name-${possessionIndex}-${index}`} label="Level crossing">
          {(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`${path}.level_crossing`, event.target.value)} value={data.level_crossing || ""} />}
        </FormField>
        <FormField helpText="Use the operational status guide below." id={`level-crossing-status-${possessionIndex}-${index}`} label="Operational status">
          {(fieldProps) => <Select {...fieldProps} onChange={(event) => props.handleInputChange(`${path}.operational_status`, event.target.value)} placeholder="Select status" value={data.operational_status || ""}>{statusOptions.map((status) => <option key={status} value={status}>{status}</option>)}</Select>}
        </FormField>
        <SearchSelect
          closeMenuOnSelect={false}
          id={`level-crossing-lines-${possessionIndex}-${index}`}
          isMulti
          label="Lines at site"
          onChange={(options) => props.handleInputChange(`${path}.lines`, (options || []).map((option) => ({ line_reference: option.value, name: option.label })))}
          options={lineOptions}
          value={selected}
        />
      </div>
    </section>
  );
};

export default LevelCrossing;
